import { Component, OnInit } from '@angular/core';

import { Message } from 'primeng/primeng';
import { LocalStorageService } from 'angular-2-local-storage';
import * as moment from 'moment';
import * as _ from 'lodash';
import { User } from '../../model/user';

import {
  IError
} from '../../model/types';

import {
  IReceipt,
  IReceiptRow,
  Receipt
} from '../../model/receipt';

import {
  Balance,
  IBalance
} from '../../model/balance';
import { Images } from '../preview/preview.component';


@Component({
    selector: 'finance-component',
    template: require('./finance.component.html'),
    styles: [require('./finance.component.css')]
})

export class FinanceComponent implements OnInit {

  public receipts : IReceipt[]    = [];
  public receiptsLoaded : boolean = false;

  public balances : IBalance[]    = [];
  public balancesLoaded : boolean = false;

  public loaded : boolean = false;

  public vatPcs      = [0, 10, 24, 100];
  public whos = ['Lexa', 'Pete'];

  public editingBalance : IBalance  = null;
  public editingReceipt : IReceipt = null;
  public editingRow : IReceiptRow = null;

  public errors : IError[];
  public alerts : Message[]        = [];
  public sort = ['date'];
  public receiptSort = ['date'];
  public newTag : string;
  public tagName : string;

  constructor (private ReceiptResource : Receipt,
               private BalanceResource : Balance,
               private localStorageService : LocalStorageService,
               private UserResource : User) {
  }

  public ngOnInit () {
    document.getElementsByClassName("frontPageTop")[0].innerHTML    = '';
    document.getElementsByClassName("frontPageBottom")[0].innerHTML = '';

    this.loadReceipts();
    this.loadBalances();
  }

  public addTag() {
    if (this.editingReceipt.tags.indexOf(this.newTag) < 0) {
      this.editingReceipt.tags.push(this.newTag);
      this.newTag = '';
    }
  }

  public removeTag(tag : string) {
    this.editingReceipt.tags.splice(this.editingReceipt.tags.indexOf(tag), 1);
  }

  public q(month : number) : number {
    return Math.ceil(month / 3);
  }

  public calculations(type : string) : number{
    switch (type) {
      case 'yearBalance':
        return _.map(this.receipts, 'amount').reduce((a, b) => a + b, 0) * -1;
      case 'moneyIn':
        return _.map(this.receipts, 'amount').reduce((a, b) => a + (b < 0 ? b : 0), 0);
      case 'moneyOut':
        return _.map(this.receipts, 'amount').reduce((a, b) => a + (b > 0 ? b : 0), 0);
      case 'preTax':
        let tax = 0;
        _.map(this.receipts, (receipt : IReceipt) => {
          if (receipt.tags.indexOf('ev') > -1) {
            tax += receipt.amount;
          }
        });
        return tax;
      case 'vatPaid':
        return _.map(this.receipts, 'vatAmount').reduce((a, b) => a + (b > 0 ? b : 0), 0);
      case 'vatReceived':
        return _.map(this.receipts, 'vatAmount').reduce((a, b) => a + (b < 0 ? b : 0), 0);
      case 'vatReturned':
        let vat = 0;
        _.map(this.receipts, (receipt : IReceipt) => {
          if (receipt.tags.indexOf('alvp') > -1) {
            vat += Number(receipt.amount);
          }
        });
        return vat;
      case 'vatBalance':
        return _.map(this.receipts, 'vatAmount').reduce((a, b) => a + b, 0)
         + this.calculations('vatReturned');

      case 'tag':
        let value = 0;
        _.map(this.receipts, (receipt : IReceipt) => {
          if (receipt.tags.indexOf(this.tagName) > -1) {
            value += receipt.amount;
          }
        });
        return value;

      case 'balanceLexa':
        let Lvalue = 0;
        _.map(this.balances, (balance : IBalance) => {
          if (balance.who === 'Lexa') {
            Lvalue += balance.amount;
          }
        });
        return Lvalue;

      case 'balancePete':
        let Pvalue = 0;
        _.map(this.balances, (balance : IBalance) => {
          if (balance.who === 'Pete') {
            Pvalue += balance.amount;
          }
        });
        return Pvalue;

    }
    return 0;
  }
  private loadReceipts() {
    this.receiptsLoaded = false;
    this.ReceiptResource.query()
      .$observable
      .subscribe((receipts: IReceipt[]) => {
        receipts.forEach((r) => r.date = r.date && moment(r.date).toDate());
        this.receipts = receipts;
        this.receiptsLoaded = true;
      });
  }

  private loadBalances() {
    this.balancesLoaded = false;
    this.BalanceResource.query()
      .$observable
      .subscribe((balances: IBalance[]) => {
        balances.forEach((b) => b.date = b.date && moment(b.date).toDate());
        this.balances = balances;
        this.balancesLoaded = true;
      });
  }

  public showRows() {
    this.receipts.forEach((receipt) => receipt.showRows = true);
  }

  public hideRows() {
    this.receipts.forEach((receipt) => receipt.showRows = false);
  }

  public invertRows() {
    this.receipts.forEach((receipt) => receipt.showRows = !receipt.showRows);
  }

  public calcVat(o) {
      o.vatAmount = Math.floor( o.amount - (o.amount / ((100 + Number(o.vat)) / 100)));
  }

  public setSort(sort : string[]) {
      this.sort = sort;
  }

  public getUsedImages() {
    return this.receipts.map((receipt) => receipt.img);
  }

  public addNewReceipt () {
    this.editingReceipt = Receipt.newReceipt();
  }

  public editReceipt (receipt : IReceipt) {
    receipt.dirty = true;
    receipt.date = receipt.date && moment(receipt.date).toDate();
    this.editingReceipt = receipt;
  }

  public removeReceipt (receipt : IReceipt) {
      if (confirm('Poista #' + receipt.id)) {
          this.ReceiptResource.remove({id : receipt.id})
              .$observable
              .subscribe(() => {
                  this.receipts.splice(this.receipts.indexOf(receipt), 1);
              });
      }
  }

  public addRow (receipt : IReceipt) {
    receipt.dirty = true;
    receipt.showRows = true;
    const newRow = Receipt.newRow();
    receipt.rows.push(newRow);
    this.editRow(newRow);
  }

  public editRow (row : IReceiptRow) {
    this.editingRow = row;
  }

  public removeRow (receipt : IReceipt, row : IReceiptRow) {
    receipt.dirty = true;
    receipt.rows.splice(receipt.rows.indexOf(row), 1);
  }

  public addNewBalance () {
    this.editingBalance = Balance.newBalance();
  }

  public editBalance (balance : IBalance) {
    balance.date = balance.date && moment(balance.date).toDate();
    this.editingBalance = balance;
  }

  public removeBalance (balance : IBalance) {
      if (confirm('Poista #' + balance.id)) {
          this.BalanceResource.remove(balance)
              .$observable
              .subscribe(() => {
                  this.balances.splice(this.balances.indexOf(balance), 1);
              });
      }
  }

  public saveReceipt (receipt : IReceipt) {
    let copy  = Object.assign({}, receipt) as IReceipt;
    copy.date = copy.date && moment(copy.date).format('YYYY-MM-DD');

    this.ReceiptResource.save(copy)
        .$observable
        .subscribe((savedReceipt : IReceipt) => {
          savedReceipt.date = savedReceipt.date && moment(savedReceipt.date).toDate();
          _.merge(receipt, savedReceipt);
          if (!copy.id) {
            this.receipts.push(receipt);
          }
          //console.log(receipt);
          this.errors = null;
          this.alerts = [];
          receipt.dirty = false;
          this.editingReceipt = null;
        }, (response) => {
          let errors = response.json();
          if (errors.errors) {
            this.errors = errors;
          } else if (errors.message) {
            this.alerts.push({severity: 'error', summary: 'Virhe tallennuksessa', detail: errors.message});
          }
          // console.log(errors);
        });
  }


  public saveBalance (balance : IBalance) {
    let copy  = Object.assign({}, balance);
    copy.date = copy.date && moment(copy.date).format('YYYY-MM-DD');

    this.BalanceResource.save(copy)
        .$observable
        .subscribe((savedBalance : IBalance) => {
          savedBalance.date = savedBalance.date && moment(savedBalance.date).toDate();
          _.merge(balance, savedBalance);
          if (!copy.id) {
            this.balances.push(balance);
          }
          // console.log(balance);
          this.errors = null;
          this.alerts = [];
          this.editingBalance = null;
        }, (response) => {
          let errors = response.json();
          if (errors.errors) {
            this.errors = errors;
          } else if (errors.message) {
            this.alerts.push({severity: 'error', summary: 'Virhe tallennuksessa', detail: errors.message});
          }
          // console.log(errors);
        });
  }

  public logout () {
    this.UserResource.logout()
        .$observable
        .subscribe(() => {
          this.localStorageService.set('user', null);
          document.location.href = '/';
        });
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/admin/finance/finance.component.ts